<template>
	<span>
        <b-modal id="modalConfirm"
                 ref="modalConfirm"
                 title='Confirm'
                 @ok="onclick"
				 ok-title="Yes" 
				 close-title="No"
				 v-model="showmodal">
            <p>{{message}}</p>
        </b-modal>
	</span>
</template>


<script>

export default {
  name: 'confirm',
  props: [],
  data () {
		return {
			message : null,
			showmodal: false,
			callbackfunction : null
		}
	  },
  methods: {
		onclick: function() {
			if (this.callbackfunction != null)
				this.callbackfunction();
		},
		confirm(msg, callback) {
			this.showmodal = true;
			this.message = msg;
			this.callbackfunction = callback;
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// confirm.vue?88e0f7ac